export default abstract class ListModel<T> {
  protected _list: T[] = [];

  constructor () {}

  public get getAll (): T[] {
    return this._list;
  }

  public get getSize (): number {
    return this._list.length;
  }

  public get getLast (): T {
    if (this.getSize > 0) {
      return this._list[this.getSize - 1];
    }
    throw new Error("No item found");
  }

  public get (idx: number): T {
    return this._list[idx];
  }

  public add (item: T): void {
    this._list.push(item);
  }

  public addAll (items: T[]): this {
    this._list.push(...items);
    return this;
  }

  public replace (oldItem: T, newItem: T): void {
    const idx: number = this._list.indexOf(oldItem);
    if (idx === -1) {
      throw new Error("Could not replace item, old item not found");
    }

    this._list[idx] = newItem;
  }

  public removeByKey (key: keyof T, value: any): void {
    this._list.splice(this._list.findIndex(x => x[key] === value), 1);
  }

  public clearList (): void {
    this._list = [];
  }

  public getByKey (key: keyof T, value: any): T|undefined {
    return this._list.find(x => x[key] === value);
  }

  public getByKeys (keys: (keyof T)[], values: any[]): T|undefined {
    return this._list.find(x => {
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const value = values[i];
        if (x[key] !== value) return false;
      }
      return true;
    });
  }

  public getAllByKeys (key: keyof T, values: any[]): T[] {
    return this._list.filter(x => values.includes(x[key]));
  }

  public getIdxByKey (key: keyof T, value: any): number {
    return this._list.findIndex(x => x[key] === value);
  }

  public hasSome (key: keyof T, value: any): boolean {
    return this._list.some(x => x[key] === value);
  }

  // check wether a deep nested property of this type exists and has a certain value
  public hasSomeDeep (key: string, value: any): boolean {
    return this._list.some(x => {
      const keys = key.split(".");
      let obj = x;
      for (const k of keys) {
        obj = obj[k as keyof unknown];
        if (obj === undefined) return false;
      }
      return obj === value;
    });
  }

  public switchPlaces (fromIdx: number, toIdx: number): void {
    const item = this._list[fromIdx];
    this._list.splice(fromIdx, 1);
    this._list.splice(toIdx, 0, item);
  }

  public moveToIdx (item: T, toIdx: number): void {
    const fromIdx = this._list.indexOf(item);
    this.switchPlaces(fromIdx, toIdx);
  }
}
